import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  DialogActions,
  Typography,
} from "@mui/material";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  whiteSpace: "nowrap",
};

const DeleteUser = ({ theme, deleteUser, disabled = false }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleModal = () => {
    if (disabled) return;
    setOpenModal((prev) => !prev);
  };

  const handleConfirm = async () => {
    if (disabled) return;
    await deleteUser();
    handleModal();
  };

  return (
    <>
      <Button
        onClick={handleModal}
        variant="outlined"
        color="error"
        theme={theme}
        fullWidth
        disabled={disabled}
        sx={buttonSx}
      >
        Delete
      </Button>
      <Dialog open={openModal} onClose={handleModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Delete user</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>
            <Typography variant="body2" color="text.secondary">
              Are you sure you want to delete this user? This action is permanent
              and cannot be undone.
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleModal} color="inherit" sx={buttonSx} theme={theme}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="error"
            theme={theme}
            sx={buttonSx}
          >
            Delete user
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteUser;
